import { usePdpCanonicalUrl } from './usePdpCanonicalUrl';

export const usePdpSEOMetaStructuredData = () => {
  const store = useMyProductPageStore();
  const canonicalUrl = usePdpCanonicalUrl();

  useSchemaOrg([
    {
      '@type': 'ProductGroup',
      name: `${store.product?.ManufacturerName} ${store.product?.ProductName}`,
      productGroupID: store.product?.ProductId,
      hasVariant: [
        {
          '@type': 'Product',
          name: `${store.product?.ManufacturerName} ${store.product?.ProductName}`,
          model: `${store.product?.ManufacturerName} ${store.product?.ProductName}`,
          sku: store.currentVariant?.Sku,
          image: store.currentVariant?.Images.at(0)?.PictureUrl,
          category: store.product?.Categories.at(0)?.CategoryName,
          brand: {
            '@type': 'Brand',
            name: store.product?.ManufacturerName ?? '',
          },
          url: canonicalUrl,
          color: store.productState.selectedColor,
          offers: {
            '@type': 'Offer',
            availability:
              store.currentVariant?.StockQuantity &&
              store.currentVariant?.StockQuantity > 0
                ? 'InStock'
                : 'OutOfStock',
            itemCondition:
              store.currentVariant?.Condition &&
              store.currentVariant?.Condition == 'Helt ny'
                ? 'NewCondition'
                : 'UsedCondition',
            url: canonicalUrl,
            shippingDetails: {
              '@type': 'OfferShippingDetails',
              shippingRate: {
                value: 0,
                currency: 'SEK',
              },
              shippingDestination: {
                addressCountry: 'SE',
              },
              deliveryTime: {
                '@type': 'ShippingDeliveryTime',
              },
            },
            price: store.currentPaymentData?.MonthlyPrice ?? 0,
            priceCurrency: 'SEK',
            priceSpecification: {
              '@type': 'CompoundPriceSpecification',
              priceComponent: [
                {
                  '@type': 'UnitPriceSpecification',
                  priceComponentType: 'Subscription',
                  price: store.currentPlan?.MonthlyFee ?? 0,
                  billingIncrement: 1,
                  unitCode: 'MON',
                  eligibleQuantity: {
                    '@type': 'QuantitativeValue',
                    value:
                      store.productState.selectedDownPaymentTime == '1'
                        ? '0'
                        : '24',
                    unitCode: 'MON',
                  },
                },
                {
                  '@type': 'UnitPriceSpecification',
                  priceComponentType: 'Downpayment',
                  price: store.currentPaymentData?.DownPayment ?? 0,
                  billingIncrement: 1,
                  unitCode: 'MON',
                  eligibleQuantity: {
                    '@type': 'QuantitativeValue',
                    value:
                      store.productState.selectedDownPaymentTime == '1'
                        ? '0'
                        : store.productState.selectedDownPaymentTime,
                    unitCode: 'MON',
                  },
                },
              ],
            },
          },
        },
      ],
    },
  ]);
};
